import { observer } from 'mobx-react-lite'
import { Box, SpinnerLoader } from 'shared/ui'
import { SelectFieldMultiList } from 'shared/ui/Select/SelectMultiListField/SelectMultiListField'
import { ChipWithAvatar } from 'entities/Phone/ui/AssignNumberCommon/ui/ChipWithAvatar/ChipWithAvatar'
import { MultiSelectDropdownContent } from 'entities/Phone/ui/AssignNumberCommon/ui/NewInboxContent/MultiSelectDropdownContent'
import { type ConversationAssignmentStore } from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/conversationAssignment/store/conversationAssignmentStore'
import styles from 'pages/settings/pages/inboxes/pages/id/pages/settings/messaging/conversationAssignment/styles.module.scss'

export const RoundRobinConversationAssignment = observer(
  ({ store }: { store: ConversationAssignmentStore }) => {
    const {
      tabSwitchingLoading,
      membersLoading,
      selectedRoundRobinMembers,
      setSelectedRoundRobinMember,
      deleteSelectedRoundRobinMember,
      updateRoundRobinUsers,
      roundRobinMembersError,
      clearRoundRobinMembersError,
      filteredRoundRobinMembers,
    } = store

    const handleClose = () => {
      clearRoundRobinMembersError()
      updateRoundRobinUsers()
    }

    return (
      <>
        {tabSwitchingLoading || membersLoading ? (
          <Box display='flex' justifyContent='center' alignItems='center' minHeight='200px'>
            <SpinnerLoader ariaLabel={'RoundRobinConversationAssignment'} />
          </Box>
        ) : (
          <SelectFieldMultiList
            withInitialSearch
            ChipComponent={ChipWithAvatar}
            labelText='Select the inbox members you want to include in round robin assignment'
            error={roundRobinMembersError}
            maxVisibleChips={5}
            placeholderClassName={styles.multiSelectPlaceholder}
            dropdownProps={{
              PopperProps: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                      // @ts-ignore
                      offset: ({ reference }) => {
                        return [0, -reference.height - 8]
                      },
                    },
                  },
                ],
              },
              onClose: handleClose,
            }}
            items={filteredRoundRobinMembers}
            selectedItems={selectedRoundRobinMembers}
            onDelete={deleteSelectedRoundRobinMember}
            onSelect={setSelectedRoundRobinMember}
            fullWidth
            customComponent={() => (
              <MultiSelectDropdownContent
                ChipComponent={ChipWithAvatar}
                items={filteredRoundRobinMembers}
                selectedItems={selectedRoundRobinMembers}
                onSelect={setSelectedRoundRobinMember}
                onDelete={deleteSelectedRoundRobinMember}
                notFoundText='No more members'
                shouldShowNotFoundText
              />
            )}
          />
        )}
      </>
    )
  }
)
